<script setup lang="ts">
import type {Faq} from '~/payload-types'

const props = defineProps<{
  faqs?: Faq[]
}>()

const {fullPath} = useRoute()
const {$scrollTo} = useNuxtApp()

/**
 * added SchemaORG for our FAQ section page.
 * this generates structured data (JSON-LD) that helps search engines
 * the HTML tags are stripped from the body text to ensure clean schema markup.
 */

useSchemaOrg([
  {
    '@type': 'FAQPage',
    mainEntity: computed(
      () =>
        props.faqs?.map(item => ({
          '@type': 'Question',
          name: item.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: (item.body as unknown as string)?.replace?.(/<[^>]*>/g, '')?.trim() ?? '',
          },
        })) || []
    ),
  },
])

onMounted(() => {
  if (fullPath.includes('faq') && window?.innerWidth < 768) {
    $scrollTo('faq')
  }
})
</script>

<template>
  <div>
    <div class="mb-8 space-y-2">
      <Heading class="scroll-mt-40 !text-xl md:!text-2xl" id="faq">
        {{ $t('contact.faq.title') }}
      </Heading>
      <Paragraph>
        {{ $t('contact.faq.description') }}
      </Paragraph>
    </div>
    <Accordion v-if="faqs" :items="faqs" />
  </div>
</template>
